module.exports = __webpack_public_path__ + "static/media/permissoes.79e906be.jpeg";